import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import OrderSignResult from '../../../components/order-sign-result/order-sign-result';
import AppPageMain from '../../../modules/app-page/app-page--main';
import IconBtn from '../../../modules/icon-btn/icon-btn';
import PageHeader from '../../../modules/page-header';
import { RootState } from '../../../types';
import currencyFormat from '../../../utils/currencyFormat';

const AssetsResultPage: React.FC = () => {
  const history = useHistory();
  const resultState = useSelector(
    (state: RootState) => state.signResult.buyingCfa
  );
  const sum = useSelector(
    (state: RootState) => state.operationsSign.data.lastPurchase.amount
  );
  const historySum = history.location.state?.sum;

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                { link: '/assets', title: 'Активы' },
                { link: '#', title: 'Денежные требования' },
              ]}
              iconType="assets"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <OrderSignResult
              title={`Заявка на покупку ЦФА на сумму ${currencyFormat(
                historySum || sum || 0
              )} успешно отменена`}
              text=" "
              loading={false}
              submitBtn={
                <div className="flex">
                  <IconBtn
                    title="Купить цфа"
                    onClick={() => history.push('/assets/buying')}
                  />
                  <IconBtn
                    title="Перейти в активы"
                    onClick={() => history.push('/assets')}
                  />
                </div>
              }
              success={!!resultState.success || true}
              successIcon={
                <svg width="92" height="80" viewBox="0 0 92 80" fill="none">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.62791 0H83.9356C88.1503 0 91.5671 3.41682 91.5671 7.63148V57.2486C91.5671 61.4633 88.1503 64.8801 83.9356 64.8801H76.3005V80L61.1807 64.8801H7.62791C3.41682 64.8801 0 61.4633 0 57.2486V7.63148C0 3.41682 3.41324 0 7.62791 0ZM83.9356 61.0626C86.0358 61.0626 87.7495 59.3524 87.7495 57.2486V7.63148C87.7495 5.52773 86.0393 3.81753 83.9356 3.81753H7.62791C5.52773 3.81753 3.81395 5.52773 3.81395 7.63148V57.2486C3.81395 59.3524 5.52415 61.0626 7.62791 61.0626H62.7621L72.4866 70.7871V61.0626H83.9356ZM60.4804 37.8509C64.737 31.0803 63.9342 22.0161 58.0451 16.1276C51.2082 9.29079 40.0863 9.29079 33.2495 16.1276C27.3125 22.064 26.5386 31.2307 30.9128 38.0182L26.1204 46.0235C25.966 46.2825 25.9594 46.6037 26.1046 46.8677C26.2491 47.1325 26.523 47.301 26.8244 47.3102L34.3975 47.5385L37.7919 53.8606C37.9363 54.1304 38.2152 54.3014 38.5207 54.3089H38.5406C38.8386 54.3089 39.1159 54.152 39.2703 53.8955L44.0127 45.973C44.5563 46.0234 45.1017 46.0509 45.6473 46.0509C46.255 46.0509 46.8621 46.0135 47.4672 45.9509L52.2442 53.9312C52.3986 54.1877 52.675 54.3446 52.9739 54.3446H52.9938C53.2993 54.3371 53.5782 54.1661 53.7227 53.8963L57.1178 47.5741L64.6902 47.3459C64.9915 47.3367 65.2654 47.1682 65.4099 46.9034C65.5552 46.6394 65.5485 46.3182 65.3941 46.0592L60.4804 37.8509ZM38.5805 51.7364L35.6626 46.3016C35.519 46.0334 35.2434 45.8633 34.9396 45.8533L28.3236 45.6541L31.9947 39.5221C32.3847 40.0056 32.8004 40.4751 33.2495 40.9241C35.7859 43.4605 38.9127 45.0506 42.1911 45.7048L38.5805 51.7364ZM34.4515 39.7221C28.2779 33.5485 28.2779 23.5032 34.4515 17.3296C37.5379 14.2433 41.593 12.7001 45.6473 12.7001C49.7016 12.7001 53.7567 14.2433 56.8431 17.3296C63.0167 23.5032 63.0167 33.5485 56.8431 39.7221C50.6703 45.8948 40.6242 45.8948 34.4515 39.7221ZM56.5758 45.889C56.2719 45.899 55.9963 46.0691 55.8527 46.3373L52.934 51.7729L49.2767 45.6626C52.4915 44.9872 55.5537 43.4155 58.0451 40.9241C58.5391 40.4302 58.9868 39.9084 59.4094 39.3729L63.191 45.6898L56.5758 45.889ZM53.9434 20.2297C49.3695 15.6557 41.925 15.6557 37.351 20.2297C35.1346 22.4461 33.9143 25.3922 33.9143 28.5259C33.9143 31.6604 35.1346 34.6065 37.351 36.822C39.5674 39.0385 42.5135 40.2587 45.6472 40.2587C48.7809 40.2587 51.727 39.0385 53.9434 36.822C56.1598 34.6065 57.3801 31.6604 57.3801 28.5259C57.3801 25.3922 56.1598 22.4461 53.9434 20.2297ZM52.7414 35.62C50.8462 37.5152 48.3268 38.5587 45.6472 38.5587C42.9676 38.5587 40.4482 37.5152 38.553 35.62C36.6579 33.7249 35.6144 31.2063 35.6144 28.5259C35.6144 25.8462 36.6579 23.3268 38.553 21.4317C40.5088 19.4759 43.078 18.4989 45.6472 18.4989C48.2164 18.4989 50.7856 19.4767 52.7414 21.4317C54.6366 23.3268 55.68 25.8462 55.68 28.5259C55.68 31.2063 54.6366 33.7249 52.7414 35.62Z"
                    fill="#4EBD25"
                  />
                </svg>
              }
              tableHeader="Статус операции"
            />
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};
export default AssetsResultPage;
